import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CAR_RUNNER_LEADERBOARD_QUERY_KEY,
  CAR_RUNNER_SCORE_API_RESOURCE,
  type CarRunnerLeaderboardResponse,
} from "./use-car-runner-leaderboard.query";

const CAR_RUNNER_SCORE_SUBMIT_API_PATH = `/v1/${CAR_RUNNER_SCORE_API_RESOURCE}` as const;

export type CarRunnerScoreSubmitBody =
  paths[typeof CAR_RUNNER_SCORE_SUBMIT_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export function useCarRunnerScoreSubmitMutation() {
  const queryClient = useQueryClient();

  return useMutation<CarRunnerLeaderboardResponse, Error, CarRunnerScoreSubmitBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<CarRunnerLeaderboardResponse>(
        CAR_RUNNER_SCORE_SUBMIT_API_PATH,
        body,
      );
      return response.data;
    },
    onSuccess: async (leaderboard) => {
      await queryClient.cancelQueries({ queryKey: CAR_RUNNER_LEADERBOARD_QUERY_KEY });
      queryClient.setQueryData(CAR_RUNNER_LEADERBOARD_QUERY_KEY, leaderboard);
      await queryClient.invalidateQueries({ queryKey: CAR_RUNNER_LEADERBOARD_QUERY_KEY });
    },
  });
}
